// extracted by mini-css-extract-plugin
export default {"container":"Gzgt9v","spacing":"kkffHK","button":"Sp9dtH"};